import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ModalClose } from '../components/modal-close.tsx';


export default function ModalInfoVersteuerndesHaushaltseinkommen() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel>
            <h1 id="modal-title">Soziale Förderung: Einkommensbonus und Familienzuschlag</h1>
            <p id="modal-description">Den Einkommensbonus erhalten Eigentümer, die ihre Immobilie selbst bewohnen. Voraussetzung ist ein durchschnittliches zu versteuerndes Haushaltseinkommen bis 50.000 € pro Jahr (Nachweis über die Einkommensteuerbescheide). Familienzuschlag: Für im Haushalt lebende minderjährige Kinder werden einmalig 10.000 € vom zu versteuernden Haushaltseinkommen abgezogen. Dadurch können mehr Haushalte den Einkommensbonus erhalten.</p>
             <ModalClose label={"schließen"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

